import { render, staticRenderFns } from "./qdBasicInformation.vue?vue&type=template&id=05d6bb55&scoped=true"
import script from "./qdBasicInformation.vue?vue&type=script&lang=js"
export * from "./qdBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./qdBasicInformation.vue?vue&type=style&index=0&id=05d6bb55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6bb55",
  null
  
)

export default component.exports